import api from './api';
import { authStore } from './authStore';

// Cache pour stocker les dernières positions
let lastPositions = null;
let lastFetchTime = 0;
let lastTransporteurId = null;
const CACHE_DURATION = 5000; // 5 secondes de cache
let pendingRequest = null;

export const getChauffeursPositions = async (transporteurId) => {
    const now = Date.now();

    // Si nous avons des données en cache et qu'elles sont récentes, les retourner
    // On ignore le cache si le transporteurId a changé
    if (!transporteurId && lastPositions && (now - lastFetchTime) < CACHE_DURATION && lastTransporteurId === transporteurId) {
        return lastPositions;
    }

    // Si une requête est déjà en cours, on la laisse finir sauf si elle ne correspond pas au transporteurId
    if (pendingRequest && lastTransporteurId === transporteurId) {
        return pendingRequest;
    }

    const userType = authStore.getState().user?.userType;
    // Default to transporteur endpoint; expediteur uses mission-scoped call instead
    const url = userType === 'expediteur' ? '/expediteur/positions' : '/transporteur/chauffeurs/positions';

    lastTransporteurId = transporteurId;

    // Créer une promesse qui retourne toujours un tableau de positions,
    // même si plusieurs appels concurrents sont faits.
    pendingRequest = api.get(url, {
        params: { transporteurId },
        headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
        }
    })
        .then((response) => {
            const positions = Array.isArray(response.data) ? response.data : [];
            lastPositions = positions;
            lastFetchTime = Date.now();
            return positions;
        })
        .catch((error) => {
            // Propager l'erreur après avoir nettoyé l'état
            throw error;
        })
        .finally(() => {
            pendingRequest = null;
        });

    return pendingRequest;
};

export const getPositionsForMissionAsExpediteur = async (missionId) => {
    const response = await api.get(`/expediteur/missions/${missionId}/positions`, {
        headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
        }
    });
    return Array.isArray(response.data) ? response.data : [];
};

export const updateChauffeurPosition = async (position) => {
    try {
        const response = await api.post('/chauffeur/position', position);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getChauffeurGpsHistory = async (chauffeurId, start, end) => {
    const response = await api.get(`/transporteur/chauffeurs/${chauffeurId}/gps-history`, {
        params: { start, end }
    });
    return Array.isArray(response.data) ? response.data : [];
};

export const getVehiculeGpsHistory = async (vehiculeId, start, end) => {
    const response = await api.get(`/transporteur/vehicules/${vehiculeId}/gps-history`, {
        params: { start, end }
    });
    return Array.isArray(response.data) ? response.data : [];
};

export const getMissionGpsHistory = async (missionId) => {
    const response = await api.get(`/transporteur/missions/${missionId}/gps-history`);
    return Array.isArray(response.data) ? response.data : [];
};

export const getMissionTimeline = async (missionId) => {
    const response = await api.get(`/gps-timeline/mission/${missionId}`);
    return Array.isArray(response.data) ? response.data : [];
};
